var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Top'),_c('Nav'),_c('div',{staticClass:"shopMain",attrs:{"id":"shopmain"}},[_c('Recommend'),_c('Activity'),_c('Phone'),_c('Computer')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }